import { GfsOfferContactPage } from "@/services/backend/gfs/offer/components/offer-contact-page";

export default function GfsOfferContactRoute() {
  return <GfsOfferContactPage />;
}
